<template>
    <section class="services-composition" v-show="isPreloader || services?.length">
        <div class="services-composition__container container">
            <div class="services-composition__content">
                <!-- HEADING COLUMN -->
                <div class="services-composition__content__column">
                    <!-- CARD -->
                    <div class="services-composition__content__column__card --heading">
                        <h2>{{ $t('servicesCompositionTitle') }}</h2>
                    </div>
                    <!-- CARD -->
                    <div class="services-composition__content__column__card --pattern-linear">
                        <div class="services-composition__content__column__card__pattern-linear">
                            <img
                                src="@/themes/novaporta/assets/images/patterns/perpendicular-lines-vertical.png"
                                alt="perpendicular-lines-vertical"
                            />
                        </div>
                    </div>
                </div>

                <!-- SKELETON COLUMN -->
                <template v-if="isPreloader">
                    <div v-for="(skeletonId, idx) in Array(3)" :key="skeletonId" class="services-composition__content__column">
                        <!-- CARD -->
                        <div class="services-composition__content__column__card --media">
                            <div class="services-composition__content__column__card__img">
                                <MySkeleton />
                            </div>
                        </div>

                        <!-- CARD -->
                        <div class="services-composition__content__column__card --item --skeleton">
                            <MySkeleton />
                            <MySkeleton />
                            <MySkeleton />
                            <MySkeleton />
                        </div>

                        <div v-if="idx === 0" class="services-composition__content__column__pattern-texture-separator">
                            <img
                                src="@/themes/novaporta/assets/images/patterns/wood-texture-lines.png"
                                alt="wood-texture-lines"
                            />
                        </div>
                    </div>
                </template>

                <!-- COLUMN -->
                <template v-else>
                    <div v-for="(item, idx) in services" :key="item.id" class="services-composition__content__column">
                        <!-- CARD -->
                        <div class="services-composition__content__column__card --media">
                            <div v-if="isPreloader" class="services-composition__content__column__card__img">
                                <MySkeleton />
                            </div>
                            <div v-else-if="item.image" class="services-composition__content__column__card__img">
                                <img :src="item.image" :alt="item.title" />
                            </div>
                            <div v-else class="services-composition__content__column__card__pattern-texture">
                                <img
                                    src="@/themes/novaporta/assets/images/patterns/wood-texture-lines.png"
                                    alt="wood-texture-lines"
                                />
                            </div>
                        </div>
                        <!-- CARD -->
                        <div v-if="!isPreloader" class="services-composition__content__column__card --item">
                            <img :src="item.icon" alt="icon" />
                            <h4>{{ item.title }}</h4>
                            <p>{{ item.description }}</p>
                            <MyActionBtn
                                v-if="item.link"
                                :theme="'dark'"
                                :size="'medium'"
                                :type="'icon'"
                                :icon="'arrowCornerIcon'"
                                :disabled="false"
                                :urlPath="renderLink(item.link)"
                            />
                        </div>
                        <div v-else class="services-composition__content__column__card --item --skeleton">
                            <MySkeleton />
                            <MySkeleton />
                            <MySkeleton />
                            <MySkeleton />
                        </div>

                        <div v-if="idx === 0" class="services-composition__content__column__pattern-texture-separator">
                            <img
                                src="@/themes/novaporta/assets/images/patterns/wood-texture-lines.png"
                                alt="wood-texture-lines"
                            />
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import VueTypes from 'vue-types';
import { createServicesCompositionItem, ServicesCompositionItem } from './types';

export default {
    name: 'ServicesComposition',
    props: {
        // services: VueTypes.arrayOf(ServicesCompositionItem).def([])
    },
    data() {
        return {
            services: []
        };
    },
    watch: {
        $route: '$fetch'
    },
    computed: {
        isPreloader() {
            return this.isLoad ? this.services.length === 0 : false;
        }
    },
    components: {
        MyActionBtn: () => import('@/themes/novaporta/components/ui/MyActionBtn'),
        MySkeleton: () => import('@/themes/novaporta/components/ui/MySkeleton')
    },
    methods: {
        renderLink(link) {
            const path = link.replace('https://', '').replace('http://', '').split('/')[1];
            if (path) {
                return `/${path}`;
            }
            return '/';
        },
        async fetchServicesComposition() {
            this.isLoad = true;
            try {
                const {
                    data: { service_items }
                } = await this.$api.home.getServices();
                this.services = service_items
                    ?.map(item => {
                        console.log(item);
                        if (item.name) {
                            return createServicesCompositionItem({
                                id: item.id,
                                title: item.name,
                                description: item.description,
                                image: item.image,
                                icon: item.icon,
                                link: item.link
                            });
                        }
                    })
                    .filter(item => item);
            } catch (error) {
                console.error('Failed to fetch services:', error);
                this.isLoad = false;
            } finally {
                this.isLoad = false;
            }
        }
    },
    async fetch() {
        await this.fetchServicesComposition();
    }
};
</script>

<style lang="scss">
@import '~/themes/novaporta/assets/styles/utils.scss';
@import './styles.scss';
</style>
